// extracted by mini-css-extract-plugin
module.exports = {"body":"style_body__P8JIP","avatar":"style_avatar__3LLWT","title":"style_title__34dAa","item":"style_item__1O05A"};